// extracted by mini-css-extract-plugin
module.exports = {"variantContainer":"CheckBoxTypeAddonGroup_variantContainer__pIYjA"};